import { Chip } from '@mui/material';
import React from 'react';

const TaskStatusChip = (props) => {
  const { status } = props;
  const defineStatusColor = () => {
    if (status?.code === 'TOASSIGN') {
      return 'primary';
    } else if (status?.code === 'INPROGRESS') {
      return 'warning';
    } else if (status?.code === 'SCHEDULED') {
      return 'info';
    } else if (status?.code === 'DONE') {
      return 'success';
    }
    return 'default';
  };

  return <Chip label={status?.name} color={defineStatusColor()} size="small" />;
};

export default TaskStatusChip;
